import React from "react";

import { LoadingOutlined } from "@ant-design/icons";

import { Spin } from "antd";

import { Container } from "./styled";

import { useAppToken } from "../../theme/v6/useAppToken";

type LoadingIndicatorProps = {
  tip?: React.ReactNode;
  fullPage?: boolean;
};

function LoadingIndicator({ tip, fullPage = false }: LoadingIndicatorProps) {
  const { token } = useAppToken();
  const antIcon = <LoadingOutlined style={{ fontSize: 36, color: token.colorPrimary }} spin />;

  return (
    <Container style={fullPage ? { minHeight: "100vh" } : undefined}>
      <Spin indicator={antIcon} description={tip} />
    </Container>
  );
}

export default React.memo(LoadingIndicator);
